/* eslint-disable default-param-last */
/**
 * @description Reducer sobre as manipulações de exames
 * @author Bene Lemuel Dantas Gondim
 * @file exameReducer.js
 *
 * @license Copyright (c) 2020 SIGEP DIGETI ITEP/RN
 */

import types from 'utils/actionTypes'

// Estado inicial da sessão no redux
const initialState = {
  error: null,
  nomeFuncao: '',
  dados: {
    id: '',
  },
}

const examesReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.FETCH_EXAMES: {
      return {
        ...state,
        exames: action.exames,
      }
    }

    default: {
      return state
    }
  }
}

export default examesReducer
